import React from 'react';
import KeywordsSection from '../../../sections/AdminDashboard/Keywords/Keywords';

const Keywords = () => {
  return <KeywordsSection />;
};

export default Keywords;
